export const CLASS_NAME = 'cst-dashboard-card-asset-count'
